/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Camera_DeniedInputs */

const vi_qr_camera_denied = /** @type {(inputs: Qr_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cho phép dùng camera. Bật quyền camera cho trang này trong cài đặt trình duyệt, hoặc nhập tay bên dưới.`)
};

/**

* @param {Qr_Camera_DeniedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_camera_denied = /** @type {((inputs?: Qr_Camera_DeniedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Camera_DeniedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_camera_denied(inputs)
});